import { Post, Get, Put, Delete } from '@/utils/request';

export default {
    getAllMaterialType: (params) => {
        return Post('GeotextilesLayingVessel/MaterialTypeServlet', params);
    },
    getMaterial: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getMaterialById: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getMaterialByShip: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getMaterial_nums: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getMaterial_getall: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    AddEntryMaterial: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    deleteEntryList: (params) => {
        return Post('GeotextilesLayingVessel/MaterialEnterServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getAllShip: (params) => {
        return Post('GeotextilesLayingVessel/BoatServlet', params);
    },
    getAreaList: (params) => {
        return Post('GeotextilesLayingVessel/EngineerRegionServlet', params);
        

    },
    AddMaterialAmount: (params) => {
        return Post('GeotextilesLayingVessel/MaterialUseServlet', params); 
    },
    getMaterialUseList: (params) => {
        return Post('GeotextilesLayingVessel/MaterialUseServlet', params); 
    },
    updateMaterialUseList: (params) => {
        return Post('GeotextilesLayingVessel/MaterialUseServlet', params); 
        //action=update&missionarea=1&materialtypeid=2&num=7&unit=米&materialuse_id=2
    },
    deleteMaterialUseList: (params) => {
        return Post('GeotextilesLayingVessel/MaterialUseServlet', params); 
        //action=update&missionarea=1&materialtypeid=2&num=7&unit=米&materialuse_id=2
    },
    
    getMattressList: (params) => {
        return Post('GeotextilesLayingVessel/ResetGeotextileServlet', params); 
        // action=view
    },
    addMattressList: (params) => {
        return Post('GeotextilesLayingVessel/ResetGeotextileServlet', params); 
        // action=view
    },

    getRelayingList: (params) => {
        return Post('GeotextilesLayingVessel/ResetGeotextileServlet', params); 
        // ResetGeotextileServlet?action=getall
    },
    updateRelayingList: (params) => {
        return Post('GeotextilesLayingVessel/ResetGeotextileServlet', params); 
        //action=update&missionarea=1&materialtypeid=2&num=7&unit=米&materialuse_id=2
    },
    
    deleteRelayingList: (params) => {
        return Post('GeotextilesLayingVessel/ResetGeotextileServlet', params); 
        //action=update&missionarea=1&materialtypeid=2&num=7&unit=米&materialuse_id=2
    },

    getModuleEvents:(params)=>{
        return Post('GeotextilesLayingVessel/EventTypeServlet',params)
        // action=getall&&eventmodule_id=1
    },
    getModuleManagement:(params)=>{
        return Post('GeotextilesLayingVessel/EventManagerServlet',params)
        // action=getall&&eventmodule_id=1
    },
    getEngineerRegion:(params)=>{
        return Post('GeotextilesLayingVessel/EngineerRegionServlet',params)
        // action=getall&&eventmodule_id=1
    },
    getEngineerDivisionServlet:(params)=>{
        return Post('GeotextilesLayingVessel/EngineerDivisionServlet',params)
        // action=getall&&eventmodule_id=1
    },
    
    getEngineerDivisionServlet:(params)=>{
        return Post('GeotextilesLayingVessel/EngineerDivisionServlet',params)
        // action=getall&&eventmodule_id=1
    },

    getPlannedProgressServlet:(params)=>{
        return Post('GeotextilesLayingVessel/PlannedProgressServlet',params)
        // action=getall&&eventmodule_id=1
    },


    getTaskSendingServlet:(params)=>{
        return Post('GeotextilesLayingVessel/TaskSendingServlet',params)
        // action=getall&&eventmodule_id=1
    },
    getProjectEditServlet:(params)=>{
        return Post('GeotextilesLayingVessel/ProjectEditServlet',params)
        // action=getall&&eventmodule_id=1
    },
    getAllAxis: (params) => {
        return Post('GeotextilesLayingVessel/AxisEditServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },
    getGeotextile: (params) => {
        return Post('GeotextilesLayingVessel/GeotextileServlet', params);
        // ?action=getnums_materialTypeid&materialtype_id=1
    },




    getEQDetail:(params)=>{
        return Post('GeotextilesLayingVessel/BoatInfoServlet',params)
    },
    getBoatDetail:(params)=>{
        return Post('GeotextilesLayingVessel/BoatServlet',params)
    },
    getBoatType:(params)=>{
        return Post('GeotextilesLayingVessel/BoatTypeServlet',params)
    },
    getLayerNumByids:(params)=>{
        return Post('GeotextilesLayingVessel/GraphicProgressServlet',params)
    },
}